import { useStore } from '@nanostores/react';
import { atom, onMount } from 'nanostores';

export const $isOnline = atom<boolean>(window?.navigator.onLine ?? true);

const handleOnline = () => $isOnline.set(true);
const handleOffline = () => $isOnline.set(false);

onMount($isOnline, () => {
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
});

/**
 * Returns the current network status.
 */
export function useNetworkStatus(): 'online' | 'offline' {
  const isOnline = useStore($isOnline);

  return isOnline ? 'online' : 'offline';
}
